export default __webpack_public_path__ + "static/media/saint-malo7.01792d6d.jpg";